import React from 'react'
import Seo from '../../components/Seo'
import Breadcrumb from './Breadcrumb'
import HeaderTwo from '../../components/header/HeaderTwo';
import Footer from '../../components/footer/Footer';
import PrivacyContent from './PrivacyContent'

function PrivacyPolicy() {
  return (
	<>
	<HeaderTwo/>
	<main>
	<Seo 
		title="Oliver and the Time Machine – Privacy Policy"
		description="Read the privacy policy for Oliver and the Time Machine."
		url="/privacy-policy"
	/>
	<Breadcrumb/>
	<PrivacyContent/>

	</main>
	<Footer/>
	</>
  )
}

export default PrivacyPolicy